import { Injectable } from '@angular/core';

/**
 * In-memory current translation language per project (Creator UI only).
 * Empty string = English source. Persists until changed or another project is opened.
 */
@Injectable({ providedIn: 'root' })
export class ProjectCurrentLanguageService {
  private readonly byProject = new Map<string, string>();

  private storageKey(projectId: string): string {
    return `pptgen.currentLang.${String(projectId || '').trim()}`;
  }

  get(projectId: string): string {
    const pid = String(projectId || '').trim();
    if (!pid) return '';
    const mem = String(this.byProject.get(pid) || '').trim();
    if (mem) return mem;
    try {
      return String(sessionStorage.getItem(this.storageKey(pid)) || '').trim();
    } catch {
      return '';
    }
  }

  set(projectId: string, languageShortCode: string): void {
    const pid = String(projectId || '').trim();
    if (!pid) return;
    const code = String(languageShortCode || '').trim();
    this.byProject.set(pid, code);
    try {
      const key = this.storageKey(pid);
      if (code) sessionStorage.setItem(key, code);
      else sessionStorage.removeItem(key);
    } catch {
      // ignore storage errors
    }
  }

  labelFor(code: string, languages: Array<{ LanguageShortCode: string; LanguageName: string }>): string {
    const c = String(code || '').trim();
    if (!c) return 'English (source)';
    const row = languages.find((l) => l.LanguageShortCode === c);
    return row ? `${row.LanguageShortCode} — ${row.LanguageName}` : c;
  }
}
